import React from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { Prefix } from "@utils/BasicTypes";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import Looks5Icon from "@mui/icons-material/Looks5";
import { useAppSelector } from "@store/hooks";

const name = "SideTabs"

const handleChange = (event: React.SyntheticEvent<Element, Event>, value: any) => {
    if (value || value === 0)
        ui.BookingPaymentTab = value
};

// getIcon function to get the icon for the tab based on the index of the tab
const getIcon = (index: number, valid: boolean) => {
    switch (index) {
        case 0:
            return <LooksOneIcon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
        case 1:
            return <LooksTwoIcon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
        case 2:
            return <Looks3Icon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
        case 3:
            return <Looks4Icon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
        case 4:
            return <Looks5Icon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
        default:
            return <LooksOneIcon sx={{ color: (theme) => valid ? theme.palette.success.main : theme.palette.error.main }} />;
    }
}

type A11yProps = {
    (index: number): {
        id: string
        "aria-controls": string
    }
}

const a11yProps: A11yProps = (index: number) => {
    return {
        id: `action-tab-${index}`,
        "aria-controls": `action-tabpanel-${index}`,
    };
}

type Props = {
    parent: string
    prefix: Prefix
}

const SideTabs: React.FC<Props> = ({ parent, prefix }) => {
    const BookingPaymentTab = useAppSelector(({ ui }) => ui.BookingPaymentTab)
    const isContactFormValid = useAppSelector(({ state }) => state.BookingPaymentContactValid)
    const isAddressFormValid = useAppSelector(({ state }) => state.BookingPaymentAddressValid)
    const isBillingMethodValid = useAppSelector(({ state }) => state.BookingPaymentMethodPaymentMethodsValid                )
    const isCustomerAgreed = useAppSelector(({ ui }) => ui.BookingPaymentMethodCardAgreed)
    const bookingCardSecured = useAppSelector(({ ui }) => ui.BookingCardSecured)

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { name, prefix, BookingPaymentTab, isContactFormValid, isAddressFormValid })
    return (
        <Tabs
            orientation="vertical"
            variant="scrollable"
            value={BookingPaymentTab}
            onChange={handleChange}
            aria-label="Vertical tabs for booking"
            sx={{ borderRight: 1, borderColor: 'divider', button: { maxWidth: 75, minWidth: 75 } }}>
            <Tab label="Payment Method" {...a11yProps(0)} icon={getIcon(0, isBillingMethodValid)} iconPosition="top" disabled={bookingCardSecured} />
            {isCustomerAgreed && <Tab label="Billing Contact" {...a11yProps(1)} icon={getIcon(1, isContactFormValid)} iconPosition="top" disabled={bookingCardSecured} />}
            {isCustomerAgreed && <Tab label="Billing Address" {...a11yProps(2)} icon={getIcon(2, isAddressFormValid)} iconPosition="top" disabled={bookingCardSecured} />}
            {isCustomerAgreed && <Tab label="Secure Booking" {...a11yProps(3)} wrapped icon={getIcon(3, bookingCardSecured)} iconPosition="top" disabled={!(isContactFormValid && isAddressFormValid)} />}
        </Tabs>
    );
};

export default SideTabs;
